export default "__VITE_ASSET__UrJV3RpI__"